import type { ReactNode } from 'react';
import { Navigate } from 'react-router';
import { Flex, Spinner } from '@chakra-ui/react';
import { useAuth } from '../hooks/useAuth';
import EmailVerificationModal from './EmailVerificationModal';

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <Flex
        minHeight="100vh"
        width="100%"
        backgroundColor="neutral.900"
        justifyContent="center"
        alignItems="center"
      >
        <Spinner size="xl" color="neutral.300" />
      </Flex>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      {children}
      {!user.email_verified && <EmailVerificationModal />}
    </>
  );
};

export default ProtectedRoute;
